














export default {
    "name": "PourcentageStatTag",
    "components": {}
    "props": {
        pourcentage: Number
    }
}
